"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/browser.ts
var browser_exports = {};
__export(browser_exports, {
  DiagramScriptError: () => DiagramScriptError,
  WarningCollector: () => WarningCollector,
  blueprintTheme: () => blueprintTheme,
  darkTheme: () => darkTheme,
  extendTheme: () => extendTheme,
  getAvailableThemes: () => getAvailableThemes,
  getAvailableVariants: () => getAvailableVariants,
  getDefaultTheme: () => getDefaultTheme,
  getTheme: () => getTheme,
  isValidTheme: () => isValidTheme,
  isValidVariant: () => isValidVariant,
  lightTheme: () => lightTheme,
  minimalTheme: () => minimalTheme,
  renderFlowchart: () => renderFlowchart,
  renderSequence: () => renderSequence,
  validateFlowchartSchema: () => validateFlowchartSchema,
  validateSequenceSchema: () => validateSequenceSchema
});
module.exports = __toCommonJS(browser_exports);

// src/shared/errors.ts
var DiagramScriptError = class _DiagramScriptError extends Error {
  constructor(code, message, context) {
    super(message);
    this.name = "DiagramScriptError";
    this.code = code;
    this.context = context;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, _DiagramScriptError);
    }
  }
  toJSON() {
    return {
      code: this.code,
      message: this.message,
      context: this.context
    };
  }
};
var WarningCollector = class {
  constructor(onWarning) {
    this.warnings = [];
    this.onWarning = onWarning;
  }
  /**
   * Add a warning
   */
  warn(code, message, context) {
    const warning = { code, message, context };
    this.warnings.push(warning);
    this.onWarning?.(warning);
    if (typeof process !== "undefined" && process.env?.["NODE_ENV"] !== "production") {
      console.warn(`[DiagramScript] ${code}: ${message}`, context ?? "");
    }
  }
  /**
   * Get all collected warnings
   */
  getWarnings() {
    return [...this.warnings];
  }
  /**
   * Clear all warnings
   */
  clear() {
    this.warnings = [];
  }
  /**
   * Check if there are any warnings
   */
  hasWarnings() {
    return this.warnings.length > 0;
  }
  /**
   * Set the warning callback
   */
  setCallback(onWarning) {
    this.onWarning = onWarning;
  }
};
function unknownNodeWarning(nodeId, context) {
  return {
    code: "UNKNOWN_NODE_REFERENCE",
    message: `Node "${nodeId}" does not exist${context ? ` (in ${context})` : ""}`,
    context: { nodeId, location: context }
  };
}
function invalidPositionHintWarning(hint, reason) {
  return {
    code: "INVALID_POSITION_HINT",
    message: `Invalid position hint "${hint}"${reason ? `: ${reason}` : ""}. Falling back to auto-layout.`,
    context: { hint, reason }
  };
}
function circularReferenceWarning(path) {
  return {
    code: "CIRCULAR_REFERENCE",
    message: `Circular reference detected: ${path.join(" -> ")}`,
    context: { path }
  };
}

// src/shared/themes.ts
var lightTheme = {
  name: "light",
  background: {
    fill: "#ffffff"
  },
  node: {
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    color: "#333333",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 14,
    fontWeight: "normal",
    borderRadius: 4,
    opacity: 1
  },
  edge: {
    stroke: "#333333",
    strokeWidth: 2,
    opacity: 1,
    markerEnd: "arrow"
  },
  variants: {
    default: {
      node: {},
      edge: {}
    },
    error: {
      node: { fill: "#fee2e2", stroke: "#dc2626", color: "#dc2626" },
      edge: { stroke: "#dc2626" }
    },
    success: {
      node: { fill: "#dcfce7", stroke: "#16a34a", color: "#16a34a" },
      edge: { stroke: "#16a34a" }
    },
    warning: {
      node: { fill: "#fef3c7", stroke: "#d97706", color: "#92400e" },
      edge: { stroke: "#d97706" }
    },
    info: {
      node: { fill: "#dbeafe", stroke: "#2563eb", color: "#1e40af" },
      edge: { stroke: "#2563eb" }
    }
  },
  group: {
    fill: "#f8f9fa",
    stroke: "#dee2e6",
    strokeWidth: 1,
    labelColor: "#495057",
    labelFontSize: 12
  },
  note: {
    fill: "#fffde7",
    stroke: "#fdd835",
    color: "#333333",
    fontSize: 12
  },
  fragment: {
    fill: "#f5f5f5",
    stroke: "#9e9e9e",
    labelBackground: "#e0e0e0",
    labelColor: "#333333"
  }
};
var darkTheme = {
  name: "dark",
  background: {
    fill: "#1a1a2e"
  },
  node: {
    fill: "#16213e",
    stroke: "#e8e8e8",
    strokeWidth: 2,
    color: "#e8e8e8",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 14,
    fontWeight: "normal",
    borderRadius: 4,
    opacity: 1
  },
  edge: {
    stroke: "#e8e8e8",
    strokeWidth: 2,
    opacity: 1,
    markerEnd: "arrow"
  },
  variants: {
    default: {
      node: {},
      edge: {}
    },
    error: {
      node: { fill: "#450a0a", stroke: "#f87171", color: "#fca5a5" },
      edge: { stroke: "#f87171" }
    },
    success: {
      node: { fill: "#052e16", stroke: "#4ade80", color: "#86efac" },
      edge: { stroke: "#4ade80" }
    },
    warning: {
      node: { fill: "#451a03", stroke: "#fbbf24", color: "#fcd34d" },
      edge: { stroke: "#fbbf24" }
    },
    info: {
      node: { fill: "#1e3a5f", stroke: "#60a5fa", color: "#93c5fd" },
      edge: { stroke: "#60a5fa" }
    }
  },
  group: {
    fill: "#0f3460",
    stroke: "#1a4d7c",
    strokeWidth: 1,
    labelColor: "#a0aec0",
    labelFontSize: 12
  },
  note: {
    fill: "#3d3d00",
    stroke: "#9e9d24",
    color: "#e8e8e8",
    fontSize: 12
  },
  fragment: {
    fill: "#252547",
    stroke: "#4a4a6a",
    labelBackground: "#363659",
    labelColor: "#e8e8e8"
  }
};
var minimalTheme = {
  name: "minimal",
  background: {
    fill: "#ffffff"
  },
  node: {
    fill: "transparent",
    stroke: "#666666",
    strokeWidth: 1,
    color: "#333333",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 13,
    fontWeight: "normal",
    borderRadius: 0,
    opacity: 1
  },
  edge: {
    stroke: "#666666",
    strokeWidth: 1,
    opacity: 1,
    markerEnd: "arrow"
  },
  variants: {
    default: {
      node: {},
      edge: {}
    },
    error: {
      node: { stroke: "#cc0000", color: "#cc0000" },
      edge: { stroke: "#cc0000" }
    },
    success: {
      node: { stroke: "#008800", color: "#008800" },
      edge: { stroke: "#008800" }
    },
    warning: {
      node: { stroke: "#cc6600", color: "#cc6600" },
      edge: { stroke: "#cc6600" }
    },
    info: {
      node: { stroke: "#0066cc", color: "#0066cc" },
      edge: { stroke: "#0066cc" }
    }
  },
  group: {
    fill: "transparent",
    stroke: "#cccccc",
    strokeWidth: 1,
    labelColor: "#666666",
    labelFontSize: 11
  },
  note: {
    fill: "transparent",
    stroke: "#999999",
    color: "#333333",
    fontSize: 11
  },
  fragment: {
    fill: "transparent",
    stroke: "#999999",
    labelBackground: "#f0f0f0",
    labelColor: "#333333"
  }
};
var blueprintTheme = {
  name: "blueprint",
  background: {
    fill: "#1e3a5f"
  },
  node: {
    fill: "transparent",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    color: "#ffffff",
    fontFamily: '"Courier New", monospace',
    fontSize: 12,
    fontWeight: "normal",
    borderRadius: 0,
    opacity: 1
  },
  edge: {
    stroke: "#ffffff",
    strokeWidth: 1.5,
    opacity: 0.8,
    markerEnd: "arrow"
  },
  variants: {
    default: {
      node: {},
      edge: {}
    },
    error: {
      node: { stroke: "#ff6b6b", color: "#ff6b6b" },
      edge: { stroke: "#ff6b6b" }
    },
    success: {
      node: { stroke: "#69db7c", color: "#69db7c" },
      edge: { stroke: "#69db7c" }
    },
    warning: {
      node: { stroke: "#ffd43b", color: "#ffd43b" },
      edge: { stroke: "#ffd43b" }
    },
    info: {
      node: { stroke: "#74c0fc", color: "#74c0fc" },
      edge: { stroke: "#74c0fc" }
    }
  },
  group: {
    fill: "rgba(255, 255, 255, 0.05)",
    stroke: "rgba(255, 255, 255, 0.3)",
    strokeWidth: 1,
    labelColor: "rgba(255, 255, 255, 0.7)",
    labelFontSize: 11
  },
  note: {
    fill: "rgba(255, 255, 255, 0.1)",
    stroke: "rgba(255, 255, 255, 0.4)",
    color: "#ffffff",
    fontSize: 11
  },
  fragment: {
    fill: "rgba(255, 255, 255, 0.05)",
    stroke: "rgba(255, 255, 255, 0.3)",
    labelBackground: "rgba(255, 255, 255, 0.2)",
    labelColor: "#ffffff"
  }
};
var themes = {
  light: lightTheme,
  dark: darkTheme,
  minimal: minimalTheme,
  blueprint: blueprintTheme
};
function getTheme(name) {
  return themes[name] ?? themes.light;
}
function getDefaultTheme() {
  return themes.light;
}
function getAvailableThemes() {
  return Object.keys(themes);
}
function getAvailableVariants() {
  return ["default", "error", "success", "warning", "info"];
}
function isValidTheme(name) {
  return name in themes;
}
function isValidVariant(name) {
  return getAvailableVariants().includes(name);
}
function resolveNodeStyle(theme, variant, customStyle) {
  const base = { ...theme.node };
  const variantStyle = variant && variant !== "default" ? theme.variants[variant]?.node : {};
  return { ...base, ...variantStyle, ...customStyle };
}
function resolveEdgeStyle(theme, variant, customStyle) {
  const base = { ...theme.edge };
  const variantStyle = variant && variant !== "default" ? theme.variants[variant]?.edge : {};
  return { ...base, ...variantStyle, ...customStyle };
}
function extendTheme(base, overrides) {
  const baseTheme = getTheme(base);
  return {
    ...baseTheme,
    ...overrides,
    node: { ...baseTheme.node, ...overrides.node },
    edge: { ...baseTheme.edge, ...overrides.edge },
    group: { ...baseTheme.group, ...overrides.group },
    note: { ...baseTheme.note, ...overrides.note },
    fragment: { ...baseTheme.fragment, ...overrides.fragment },
    variants: {
      ...baseTheme.variants,
      ...overrides.variants
    },
    background: { ...baseTheme.background, ...overrides.background }
  };
}

// src/layout/engine.ts
var dagre = __toESM(require("dagre"));

// src/shared/svg.ts
var XML_ESCAPE_MAP = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&apos;"
};
function escapeXml(text) {
  return text.replace(/[&<>"']/g, (char) => XML_ESCAPE_MAP[char] ?? char);
}
function escapeAttr(value) {
  return escapeXml(value);
}
function createElement(tag, attrs = {}, children = []) {
  return { tag, attrs, children };
}
function createGroup(attrs = {}, children = []) {
  return createElement("g", attrs, children);
}
function createText(x, y, content, attrs = {}) {
  return createElement(
    "text",
    {
      x,
      y,
      "text-anchor": "middle",
      "dominant-baseline": "middle",
      ...attrs
    },
    [content]
  );
}
function createRect(x, y, width, height, attrs = {}) {
  return createElement("rect", { x, y, width, height, ...attrs }, []);
}
function createCircle(cx, cy, r, attrs = {}) {
  return createElement("circle", { cx, cy, r, ...attrs }, []);
}
function createEllipse(cx, cy, rx, ry, attrs = {}) {
  return createElement("ellipse", { cx, cy, rx, ry, ...attrs }, []);
}
function createLine(x1, y1, x2, y2, attrs = {}) {
  return createElement("line", { x1, y1, x2, y2, ...attrs }, []);
}
function createPath(d, attrs = {}) {
  return createElement("path", { d, ...attrs }, []);
}
function createPolygon(points, attrs = {}) {
  const pointsStr = points.map((p) => `${p.x},${p.y}`).join(" ");
  return createElement("polygon", { points: pointsStr, ...attrs }, []);
}
function createStadium(x, y, width, height, attrs = {}) {
  const r = height / 2;
  const d = `M ${x + r} ${y}
             L ${x + width - r} ${y}
             A ${r} ${r} 0 0 1 ${x + width - r} ${y + height}
             L ${x + r} ${y + height}
             A ${r} ${r} 0 0 1 ${x + r} ${y}
             Z`;
  return createPath(d, attrs);
}
function createDiamond(cx, cy, width, height, attrs = {}) {
  const hw = width / 2;
  const hh = height / 2;
  return createPolygon(
    [
      { x: cx, y: cy - hh },
      { x: cx + hw, y: cy },
      { x: cx, y: cy + hh },
      { x: cx - hw, y: cy }
    ],
    attrs
  );
}
function createParallelogram(x, y, width, height, skew = 15, attrs = {}) {
  return createPolygon(
    [
      { x: x + skew, y },
      { x: x + width, y },
      { x: x + width - skew, y: y + height },
      { x, y: y + height }
    ],
    attrs
  );
}
function createCylinder(x, y, width, height, attrs = {}) {
  const ry = height * 0.15;
  const bodyHeight = height - ry * 2;
  const d = `M ${x} ${y + ry}
             A ${width / 2} ${ry} 0 0 1 ${x + width} ${y + ry}
             L ${x + width} ${y + ry + bodyHeight}
             A ${width / 2} ${ry} 0 0 1 ${x} ${y + ry + bodyHeight}
             Z
             M ${x} ${y + ry}
             A ${width / 2} ${ry} 0 0 0 ${x + width} ${y + ry}`;
  return createPath(d, attrs);
}
function createHexagon(cx, cy, width, height, attrs = {}) {
  const hw = width / 2;
  const hh = height / 2;
  const inset = width * 0.2;
  return createPolygon(
    [
      { x: cx - hw + inset, y: cy - hh },
      { x: cx + hw - inset, y: cy - hh },
      { x: cx + hw, y: cy },
      { x: cx + hw - inset, y: cy + hh },
      { x: cx - hw + inset, y: cy + hh },
      { x: cx - hw, y: cy }
    ],
    attrs
  );
}
function createSubroutine(x, y, width, height, inset = 10, attrs = {}) {
  return createGroup({}, [
    createRect(x, y, width, height, attrs),
    createLine(x + inset, y, x + inset, y + height, attrs),
    createLine(x + width - inset, y, x + width - inset, y + height, attrs)
  ]);
}
function createPerson(x, y, width, height, attrs = {}) {
  const centerX = x + width / 2;
  const headRadius = Math.min(width, height) * 0.15;
  const headY = y + headRadius + 5;
  const bodyTop = headY + headRadius + 5;
  const bodyBottom = y + height * 0.65;
  const armY = bodyTop + (bodyBottom - bodyTop) * 0.3;
  const legBottom = y + height - 5;
  const legSpread = width * 0.25;
  return createGroup({}, [
    // Head
    createCircle(centerX, headY, headRadius, attrs),
    // Body
    createLine(centerX, bodyTop, centerX, bodyBottom, attrs),
    // Arms
    createLine(centerX - legSpread, armY, centerX + legSpread, armY, attrs),
    // Legs
    createLine(centerX, bodyBottom, centerX - legSpread, legBottom, attrs),
    createLine(centerX, bodyBottom, centerX + legSpread, legBottom, attrs)
  ]);
}
function createComponent(x, y, width, height, attrs = {}) {
  const tabWidth = 12;
  const tabHeight = 6;
  const tabX = x + 8;
  const tabY1 = y + height * 0.25;
  const tabY2 = y + height * 0.5;
  return createGroup({}, [
    // Main rectangle
    createRect(x, y, width, height, { ...attrs, rx: 3, ry: 3 }),
    // Component tabs (two small rectangles on left side)
    createRect(tabX - tabWidth / 2, tabY1 - tabHeight / 2, tabWidth, tabHeight, {
      ...attrs,
      fill: attrs.fill || "#fff"
    }),
    createRect(tabX - tabWidth / 2, tabY2 - tabHeight / 2, tabWidth, tabHeight, {
      ...attrs,
      fill: attrs.fill || "#fff"
    })
  ]);
}
function createDatabase(x, y, width, height, attrs = {}) {
  const ellipseHeight = height * 0.15;
  const bodyHeight = height - ellipseHeight;
  const rx = width / 2;
  const ry = ellipseHeight;
  return createGroup({}, [
    // Bottom ellipse
    createEllipse(x + width / 2, y + height - ry, rx, ry, attrs),
    // Body rectangle (covers middle of ellipses)
    createRect(x, y + ry, width, bodyHeight - ry, {
      ...attrs,
      stroke: "none"
    }),
    // Side lines
    createLine(x, y + ry, x, y + height - ry, attrs),
    createLine(x + width, y + ry, x + width, y + height - ry, attrs),
    // Top ellipse (drawn last to be on top)
    createEllipse(x + width / 2, y + ry, rx, ry, attrs)
  ]);
}
function createArrowMarker(id, color = "#333", size = 10) {
  return createElement(
    "marker",
    {
      id,
      viewBox: "0 0 10 10",
      refX: 9,
      refY: 5,
      markerWidth: size,
      markerHeight: size,
      orient: "auto-start-reverse"
    },
    [createPath("M 0 0 L 10 5 L 0 10 z", { fill: color })]
  );
}
function nodeStyleToAttrs(style) {
  return {
    fill: style.fill,
    stroke: style.stroke,
    "stroke-width": style.strokeWidth,
    rx: style.borderRadius,
    ry: style.borderRadius,
    opacity: style.opacity
  };
}
function edgeStyleToAttrs(style) {
  return {
    stroke: style.stroke,
    "stroke-width": style.strokeWidth,
    "stroke-dasharray": style.dasharray,
    opacity: style.opacity,
    fill: "none",
    "marker-end": style.markerEnd === "none" ? void 0 : style.markerEnd ?? "url(#arrow)"
  };
}
function textStyleToAttrs(style) {
  return {
    fill: style.color,
    "font-family": style.fontFamily,
    "font-size": style.fontSize,
    "font-weight": style.fontWeight
  };
}
var SELF_CLOSING_TAGS = /* @__PURE__ */ new Set(["circle", "ellipse", "line", "path", "polygon", "polyline", "rect"]);
function serializeElement(element, indent = 0) {
  const { tag, attrs, children } = element;
  const spaces = "  ".repeat(indent);
  const attrParts = [];
  for (const [key, value] of Object.entries(attrs)) {
    if (value !== void 0 && value !== null) {
      attrParts.push(`${key}="${escapeAttr(String(value))}"`);
    }
  }
  const attrStr = attrParts.length > 0 ? " " + attrParts.join(" ") : "";
  if (children.length === 0 && SELF_CLOSING_TAGS.has(tag)) {
    return `${spaces}<${tag}${attrStr}/>`;
  }
  const childrenStr = children.map((child) => {
    if (typeof child === "string") {
      return `${spaces}  ${escapeXml(child)}`;
    }
    return serializeElement(child, indent + 1);
  }).join("\n");
  if (children.length === 1 && typeof children[0] === "string") {
    return `${spaces}<${tag}${attrStr}>${escapeXml(children[0])}</${tag}>`;
  }
  return `${spaces}<${tag}${attrStr}>
${childrenStr}
${spaces}</${tag}>`;
}
function serializeSvg(root, viewBox, width, height) {
  const svgAttrs = {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    viewBox: `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`,
    width: width ?? viewBox.width,
    height: height ?? viewBox.height,
    ...root.attrs
  };
  const svgElement = createElement("svg", svgAttrs, root.children);
  return '<?xml version="1.0" encoding="UTF-8"?>\n' + serializeElement(svgElement);
}
function createBackground(viewBox, style) {
  if (style.gradient) {
    const gradientId = "bg-gradient";
    const gradientDef = style.gradient.type === "linear" ? createElement(
      "linearGradient",
      {
        id: gradientId,
        gradientTransform: style.gradient.angle ? `rotate(${style.gradient.angle})` : void 0
      },
      style.gradient.stops.map(
        (stop) => createElement("stop", {
          offset: `${stop.offset * 100}%`,
          "stop-color": stop.color
        }, [])
      )
    ) : createElement(
      "radialGradient",
      { id: gradientId },
      style.gradient.stops.map(
        (stop) => createElement("stop", {
          offset: `${stop.offset * 100}%`,
          "stop-color": stop.color
        }, [])
      )
    );
    return [
      gradientDef,
      createRect(viewBox.x, viewBox.y, viewBox.width, viewBox.height, {
        fill: `url(#${gradientId})`
      })
    ];
  }
  return createRect(viewBox.x, viewBox.y, viewBox.width, viewBox.height, {
    fill: style.fill ?? "transparent"
  });
}
function measureTextWidth(text, fontSize = 14) {
  const avgCharWidth = fontSize * 0.6;
  return text.length * avgCharWidth;
}
function wrapText(text, maxWidth, fontSize = 14) {
  const words = text.split(" ");
  const lines = [];
  let currentLine = "";
  for (const word of words) {
    const testLine = currentLine ? `${currentLine} ${word}` : word;
    if (measureTextWidth(testLine, fontSize) > maxWidth && currentLine) {
      lines.push(currentLine);
      currentLine = word;
    } else {
      currentLine = testLine;
    }
  }
  if (currentLine) {
    lines.push(currentLine);
  }
  return lines;
}
function createMultilineText(x, y, lines, lineHeight = 1.2, attrs = {}) {
  const fontSize = attrs["font-size"] ?? 14;
  const totalHeight = lines.length * fontSize * lineHeight;
  const startY = y - totalHeight / 2 + fontSize / 2;
  return createGroup(
    {},
    lines.map(
      (line, i) => createText(x, startY + i * fontSize * lineHeight, line, attrs)
    )
  );
}

// src/layout/engine.ts
var DEFAULT_CONFIG = {
  direction: "TB",
  nodeSeparation: 50,
  edgeSeparation: 10,
  rankSeparation: 70,
  margin: 40
};
var DEFAULT_NODE_WIDTH = 150;
var DEFAULT_NODE_HEIGHT = 50;
var NODE_PADDING = 20;
function parsePositionHint(hint) {
  const parts = hint.split(":");
  if (parts.length !== 2) return null;
  const type = parts[0];
  const refStr = parts[1];
  if (!refStr) return null;
  const validTypes = ["below", "above", "leftOf", "rightOf", "row", "column"];
  if (!validTypes.includes(type)) return null;
  const references = type === "row" || type === "column" ? refStr.split(",").map((s) => s.trim()).filter(Boolean) : [refStr.trim()];
  if (references.length === 0) return null;
  return { type, references };
}
function calculateNodeSize(node, fontSize = 14) {
  const label = node.label || node.id;
  const textWidth = measureTextWidth(label, fontSize);
  const width = Math.max(DEFAULT_NODE_WIDTH, textWidth + NODE_PADDING * 2);
  let height = DEFAULT_NODE_HEIGHT;
  if (node.shape === "diamond") {
    height = Math.max(height, width * 0.6);
  } else if (node.shape === "cylinder") {
    height = Math.max(height, DEFAULT_NODE_HEIGHT * 1.3);
  }
  return { width, height };
}
var LayoutEngine = class {
  constructor(config, onWarning) {
    this.config = { ...DEFAULT_CONFIG, ...config };
    this.warnings = new WarningCollector(onWarning);
  }
  /**
   * Perform layout on nodes and edges
   */
  layout(nodes, edges, groups = [], alignments = []) {
    const g = new dagre.graphlib.Graph({ compound: true });
    g.setGraph({
      rankdir: this.config.direction,
      nodesep: this.config.nodeSeparation,
      edgesep: this.config.edgeSeparation,
      ranksep: this.config.rankSeparation,
      marginx: this.config.margin,
      marginy: this.config.margin
    });
    g.setDefaultNodeLabel(() => ({ width: DEFAULT_NODE_WIDTH, height: DEFAULT_NODE_HEIGHT }));
    g.setDefaultEdgeLabel(() => ({}));
    const nodeIds = new Set(nodes.map((n) => n.id));
    const nodeSizes = /* @__PURE__ */ new Map();
    for (const node of nodes) {
      if (nodeSizes.has(node.id)) {
        this.warnings.warn(
          "DUPLICATE_NODE_ID",
          `Duplicate node identifier "${node.id}" found.`,
          { nodeId: node.id }
        );
        nodeIds.delete(node.id);
        continue;
      }
      const size = calculateNodeSize(node);
      nodeSizes.set(node.id, size);
      g.setNode(node.id, {
        width: size.width,
        height: size.height,
        label: node.label || node.id
      });
    }
    for (const group of groups) {
      g.setNode(group.id, { label: group.label, width: 0, height: 0 });
      for (const nodeId of group.nodeIds) {
        if (nodeIds.has(nodeId)) {
          g.setParent(nodeId, group.id);
        } else {
          this.warnings.warn(
            "UNKNOWN_NODE_REFERENCE",
            unknownNodeWarning(nodeId, `group "${group.id}"`).message,
            { nodeId, group: group.id }
          );
        }
      }
    }
    const validEdges = [];
    for (const edge of edges) {
      if (!nodeIds.has(edge.from)) {
        this.warnings.warn(
          "UNKNOWN_NODE_REFERENCE",
          unknownNodeWarning(edge.from, "edge source").message,
          { nodeId: edge.from }
        );
        continue;
      }
      if (!nodeIds.has(edge.to)) {
        this.warnings.warn(
          "UNKNOWN_NODE_REFERENCE",
          unknownNodeWarning(edge.to, "edge target").message,
          { nodeId: edge.to }
        );
        continue;
      }
      validEdges.push(edge);
      const edgeConfig = { label: edge.label };
      if (edge.label) {
        edgeConfig.width = measureTextWidth(edge.label, 12) + 10;
        edgeConfig.height = 20;
      }
      g.setEdge(edge.from, edge.to, edgeConfig);
    }
    this.detectCircularReferences(validEdges);
    dagre.layout(g);
    const resultNodes = /* @__PURE__ */ new Map();
    for (const nodeId of g.nodes()) {
      const node = g.node(nodeId);
      if (node && !groups.some((grp) => grp.id === nodeId)) {
        resultNodes.set(nodeId, {
          id: nodeId,
          x: node.x,
          y: node.y,
          width: node.width,
          height: node.height,
          label: node.label ?? nodeId
        });
      }
    }
    this.applyPositionHints(nodes, resultNodes, nodeIds);
    this.applyAlignments(alignments, resultNodes);
    const resultGroups = [];
    for (const group of groups) {
      const bounds = this.calculateGroupBounds(group.nodeIds, resultNodes);
      if (bounds) {
        resultGroups.push({
          id: group.id,
          label: group.label,
          ...bounds,
          nodeIds: group.nodeIds
        });
      }
    }
    const resultEdges = [];
    for (const edge of validEdges) {
      const e = g.edge(edge.from, edge.to);
      if (e) {
        resultEdges.push({
          from: edge.from,
          to: edge.to,
          points: e.points ?? [],
          label: edge.label,
          labelX: e.x,
          labelY: e.y
        });
      }
    }
    const graphInfo = g.graph();
    const width = (graphInfo.width ?? 400) + this.config.margin * 2;
    const height = (graphInfo.height ?? 300) + this.config.margin * 2;
    return {
      nodes: resultNodes,
      edges: resultEdges,
      groups: resultGroups,
      width,
      height
    };
  }
  /**
   * Apply position hints to override dagre positions
   */
  applyPositionHints(nodes, resultNodes, nodeIds) {
    const GAP = 30;
    for (const node of nodes) {
      if (!node.position) continue;
      const layoutNode = resultNodes.get(node.id);
      if (!layoutNode) continue;
      const parsed = parsePositionHint(node.position);
      if (!parsed) {
        this.warnings.warn(
          "INVALID_POSITION_HINT",
          invalidPositionHintWarning(node.position, "invalid format").message,
          { hint: node.position, nodeId: node.id }
        );
        continue;
      }
      const validRefs = parsed.references.filter((ref) => {
        if (!nodeIds.has(ref)) {
          this.warnings.warn(
            "UNKNOWN_NODE_REFERENCE",
            unknownNodeWarning(ref, `position hint for "${node.id}"`).message,
            { nodeId: ref }
          );
          return false;
        }
        return true;
      });
      if (validRefs.length === 0) {
        this.warnings.warn(
          "INVALID_POSITION_HINT",
          invalidPositionHintWarning(node.position, "no valid references").message,
          { hint: node.position, nodeId: node.id }
        );
        continue;
      }
      const refNode = resultNodes.get(validRefs[0]);
      if (!refNode) continue;
      switch (parsed.type) {
        case "below":
          layoutNode.x = refNode.x;
          layoutNode.y = refNode.y + refNode.height / 2 + layoutNode.height / 2 + GAP;
          break;
        case "above":
          layoutNode.x = refNode.x;
          layoutNode.y = refNode.y - refNode.height / 2 - layoutNode.height / 2 - GAP;
          break;
        case "rightOf":
          layoutNode.x = refNode.x + refNode.width / 2 + layoutNode.width / 2 + GAP;
          layoutNode.y = refNode.y;
          break;
        case "leftOf":
          layoutNode.x = refNode.x - refNode.width / 2 - layoutNode.width / 2 - GAP;
          layoutNode.y = refNode.y;
          break;
        case "row": {
          const refNodes = validRefs.map((ref) => resultNodes.get(ref)).filter((n) => n !== void 0);
          if (refNodes.length > 0) {
            const avgY = refNodes.reduce((sum, n) => sum + n.y, 0) / refNodes.length;
            layoutNode.y = avgY;
          }
          break;
        }
        case "column": {
          const refNodes = validRefs.map((ref) => resultNodes.get(ref)).filter((n) => n !== void 0);
          if (refNodes.length > 0) {
            const avgX = refNodes.reduce((sum, n) => sum + n.x, 0) / refNodes.length;
            layoutNode.x = avgX;
          }
          break;
        }
      }
    }
  }
  /**
   * Apply alignment directives
   */
  applyAlignments(alignments, resultNodes) {
    for (const alignment of alignments) {
      const nodes = alignment.nodeIds.map((id) => resultNodes.get(id)).filter((n) => n !== void 0);
      if (nodes.length < 2) continue;
      if (alignment.direction === "horizontal") {
        const avgY = nodes.reduce((sum, n) => sum + n.y, 0) / nodes.length;
        for (const node of nodes) {
          node.y = avgY;
        }
      } else {
        const avgX = nodes.reduce((sum, n) => sum + n.x, 0) / nodes.length;
        for (const node of nodes) {
          node.x = avgX;
        }
      }
    }
  }
  /**
   * Calculate bounding box for a group
   */
  calculateGroupBounds(nodeIds, resultNodes) {
    const nodes = nodeIds.map((id) => resultNodes.get(id)).filter((n) => n !== void 0);
    if (nodes.length === 0) return null;
    const PADDING = 20;
    const LABEL_HEIGHT = 25;
    let minX = Infinity, minY = Infinity;
    let maxX = -Infinity, maxY = -Infinity;
    for (const node of nodes) {
      const left = node.x - node.width / 2;
      const right = node.x + node.width / 2;
      const top = node.y - node.height / 2;
      const bottom = node.y + node.height / 2;
      minX = Math.min(minX, left);
      minY = Math.min(minY, top);
      maxX = Math.max(maxX, right);
      maxY = Math.max(maxY, bottom);
    }
    return {
      x: minX - PADDING,
      y: minY - PADDING - LABEL_HEIGHT,
      width: maxX - minX + PADDING * 2,
      height: maxY - minY + PADDING * 2 + LABEL_HEIGHT
    };
  }
  /**
   * Detect circular references in edges
   */
  detectCircularReferences(edges) {
    const graph = /* @__PURE__ */ new Map();
    for (const edge of edges) {
      if (!graph.has(edge.from)) {
        graph.set(edge.from, []);
      }
      graph.get(edge.from).push(edge.to);
    }
    const visited = /* @__PURE__ */ new Set();
    const recStack = /* @__PURE__ */ new Set();
    const dfs = (node, path) => {
      visited.add(node);
      recStack.add(node);
      const neighbors = graph.get(node) ?? [];
      for (const neighbor of neighbors) {
        if (!visited.has(neighbor)) {
          if (dfs(neighbor, [...path, neighbor])) {
            return true;
          }
        } else if (recStack.has(neighbor)) {
          const cyclePath = [...path, neighbor];
          this.warnings.warn(
            "CIRCULAR_REFERENCE",
            circularReferenceWarning(cyclePath).message,
            { path: cyclePath }
          );
          return true;
        }
      }
      recStack.delete(node);
      return false;
    };
    for (const node of graph.keys()) {
      if (!visited.has(node)) {
        dfs(node, [node]);
      }
    }
  }
  /**
   * Get collected warnings
   */
  getWarnings() {
    return this.warnings.getWarnings();
  }
  /**
   * Update layout configuration
   */
  setConfig(config) {
    this.config = { ...this.config, ...config };
  }
};

// src/flowchart/render.ts
function renderNodeShape(node, shape, style) {
  const { x, y, width, height } = node;
  const halfW = width / 2;
  const halfH = height / 2;
  const attrs = nodeStyleToAttrs(style);
  switch (shape) {
    case "oval":
    case "stadium":
      return createStadium(x - halfW, y - halfH, width, height, attrs);
    case "diamond":
      return createDiamond(x, y, width, height, attrs);
    case "parallelogram":
      return createParallelogram(x - halfW, y - halfH, width, height, 15, attrs);
    case "cylinder":
      return createCylinder(x - halfW, y - halfH, width, height, attrs);
    case "hexagon":
      return createHexagon(x, y, width, height, attrs);
    case "subroutine":
      return createSubroutine(x - halfW, y - halfH, width, height, 10, attrs);
    case "person":
      return createPerson(x - halfW, y - halfH, width, height, attrs);
    case "component":
      return createComponent(x - halfW, y - halfH, width, height, attrs);
    case "database":
      return createDatabase(x - halfW, y - halfH, width, height, attrs);
    case "rectangle":
    default:
      return createRect(x - halfW, y - halfH, width, height, attrs);
  }
}
function renderEdgePath(edge, style) {
  const { points } = edge;
  if (points.length === 0) return createPath("", {});
  const pathParts = [];
  const firstPoint = points[0];
  pathParts.push(`M ${firstPoint.x} ${firstPoint.y}`);
  if (points.length === 2) {
    const lastPoint = points[1];
    pathParts.push(`L ${lastPoint.x} ${lastPoint.y}`);
  } else if (points.length > 2) {
    for (let i = 1; i < points.length - 1; i++) {
      const current = points[i];
      const next = points[i + 1];
      const midX = (current.x + next.x) / 2;
      const midY = (current.y + next.y) / 2;
      pathParts.push(`Q ${current.x} ${current.y} ${midX} ${midY}`);
    }
    const lastPoint = points[points.length - 1];
    pathParts.push(`L ${lastPoint.x} ${lastPoint.y}`);
  }
  const attrs = edgeStyleToAttrs(style);
  return createPath(pathParts.join(" "), attrs);
}
function renderFlowchartToSvg(schema, theme, warningCollector) {
  const layoutEngine = new LayoutEngine(schema.layout, (w) => {
    warningCollector.warn(w.code, w.message, {});
  });
  const layoutResult = layoutEngine.layout(
    schema.nodes,
    schema.edges,
    schema.groups ?? [],
    schema.alignments ?? []
  );
  const { nodes: layoutNodes, edges: layoutEdges, groups: layoutGroups, width, height } = layoutResult;
  const elements = [];
  const arrowColor = theme.edge.stroke ?? "#333";
  const defs = createElement("defs", {}, [
    createArrowMarker("arrow", arrowColor),
    createArrowMarker("arrow-dashed", arrowColor)
  ]);
  elements.push(defs);
  const viewBox = { x: 0, y: 0, width, height };
  const bgStyle = schema.background ?? theme.background;
  const bgElement = createBackground(viewBox, bgStyle);
  if (Array.isArray(bgElement)) {
    elements.push(bgElement[0]);
    elements.push(bgElement[1]);
  } else {
    elements.push(bgElement);
  }
  for (const group of layoutGroups) {
    const groupStyle = theme.group;
    const groupElement = createGroup({}, [
      createRect(group.x, group.y, group.width, group.height, {
        fill: groupStyle.fill,
        stroke: groupStyle.stroke,
        "stroke-width": groupStyle.strokeWidth,
        rx: 4,
        ry: 4
      }),
      createText(group.x + 10, group.y + 15, group.label, {
        "text-anchor": "start",
        fill: groupStyle.labelColor,
        "font-size": groupStyle.labelFontSize,
        "font-weight": "bold"
      })
    ]);
    elements.push(groupElement);
  }
  for (const layoutEdge of layoutEdges) {
    const schemaEdge = schema.edges.find(
      (e) => e.from === layoutEdge.from && e.to === layoutEdge.to
    );
    const edgeStyle = resolveEdgeStyle(
      theme,
      schemaEdge?.variant,
      schemaEdge?.style
    );
    const edgeGroup = [];
    edgeGroup.push(renderEdgePath(layoutEdge, edgeStyle));
    if (layoutEdge.label && layoutEdge.labelX !== void 0 && layoutEdge.labelY !== void 0) {
      const labelBg = createRect(
        layoutEdge.labelX - 20,
        layoutEdge.labelY - 10,
        40,
        20,
        { fill: theme.background.fill ?? "#fff", stroke: "none" }
      );
      edgeGroup.push(labelBg);
      const labelText = createText(
        layoutEdge.labelX,
        layoutEdge.labelY,
        layoutEdge.label,
        {
          fill: theme.node.color,
          "font-size": 12
        }
      );
      edgeGroup.push(labelText);
    }
    elements.push(createGroup({ class: "edge" }, edgeGroup));
  }
  for (const schemaNode of schema.nodes) {
    const layoutNode = layoutNodes.get(schemaNode.id);
    if (!layoutNode) continue;
    const nodeStyle = resolveNodeStyle(
      theme,
      schemaNode.variant,
      schemaNode.style
    );
    const shape = schemaNode.shape ?? "rectangle";
    const nodeGroup = [];
    nodeGroup.push(renderNodeShape(layoutNode, shape, nodeStyle));
    const label = schemaNode.label || schemaNode.id;
    const maxLabelWidth = layoutNode.width - 20;
    const lines = wrapText(label, maxLabelWidth, nodeStyle.fontSize ?? 14);
    if (lines.length === 1) {
      nodeGroup.push(
        createText(layoutNode.x, layoutNode.y, label, textStyleToAttrs(nodeStyle))
      );
    } else {
      nodeGroup.push(
        createMultilineText(
          layoutNode.x,
          layoutNode.y,
          lines,
          1.2,
          textStyleToAttrs(nodeStyle)
        )
      );
    }
    elements.push(
      createGroup(
        {
          class: "node",
          "data-id": schemaNode.id
        },
        nodeGroup
      )
    );
  }
  const root = createElement("g", {}, elements);
  return serializeSvg(root, viewBox, width, height);
}

// src/sequence/render.ts
var PARTICIPANT_WIDTH = 100;
var PARTICIPANT_HEIGHT = 40;
var PARTICIPANT_SPACING = 150;
var MESSAGE_HEIGHT = 40;
var NOTE_WIDTH = 120;
var NOTE_PADDING = 8;
var MARGIN = 40;
var ACTOR_HEAD_RADIUS = 15;
var SELF_MESSAGE_WIDTH = 40;
function renderActor(x, y, label, theme) {
  const headY = y + ACTOR_HEAD_RADIUS;
  const bodyTop = headY + ACTOR_HEAD_RADIUS;
  const bodyBottom = bodyTop + 25;
  const armY = bodyTop + 10;
  return createGroup({}, [
    // Head
    createElement("circle", {
      cx: x,
      cy: headY,
      r: ACTOR_HEAD_RADIUS,
      fill: "none",
      stroke: theme.node.stroke,
      "stroke-width": theme.node.strokeWidth
    }, []),
    // Body
    createLine(x, bodyTop, x, bodyBottom, {
      stroke: theme.node.stroke,
      "stroke-width": theme.node.strokeWidth
    }),
    // Arms
    createLine(x - 20, armY, x + 20, armY, {
      stroke: theme.node.stroke,
      "stroke-width": theme.node.strokeWidth
    }),
    // Legs
    createLine(x, bodyBottom, x - 15, bodyBottom + 20, {
      stroke: theme.node.stroke,
      "stroke-width": theme.node.strokeWidth
    }),
    createLine(x, bodyBottom, x + 15, bodyBottom + 20, {
      stroke: theme.node.stroke,
      "stroke-width": theme.node.strokeWidth
    }),
    // Label
    createText(x, bodyBottom + 35, label, {
      fill: theme.node.color,
      "font-size": theme.node.fontSize,
      "font-family": theme.node.fontFamily
    })
  ]);
}
function renderParticipantBox(x, y, label, theme) {
  const boxWidth = Math.max(PARTICIPANT_WIDTH, measureTextWidth(label, theme.node.fontSize ?? 14) + 20);
  return createGroup({}, [
    createRect(x - boxWidth / 2, y, boxWidth, PARTICIPANT_HEIGHT, {
      fill: theme.node.fill,
      stroke: theme.node.stroke,
      "stroke-width": theme.node.strokeWidth,
      rx: theme.node.borderRadius,
      ry: theme.node.borderRadius
    }),
    createText(x, y + PARTICIPANT_HEIGHT / 2, label, {
      fill: theme.node.color,
      "font-size": theme.node.fontSize,
      "font-family": theme.node.fontFamily
    })
  ]);
}
function renderMessage(fromX, toX, y, label, dashed, theme) {
  const attrs = {
    stroke: theme.edge.stroke,
    "stroke-width": theme.edge.strokeWidth,
    fill: "none",
    "marker-end": "url(#arrow)"
  };
  if (dashed) {
    attrs["stroke-dasharray"] = "5,3";
  }
  return createGroup({}, [
    createLine(fromX, y, toX, y, attrs),
    createText((fromX + toX) / 2, y - 10, label, {
      fill: theme.node.color,
      "font-size": 12,
      "font-family": theme.node.fontFamily
    })
  ]);
}
function renderSelfMessage(x, y, label, theme) {
  const loopWidth = SELF_MESSAGE_WIDTH;
  const loopHeight = 30;
  const path = `M ${x} ${y}
                L ${x + loopWidth} ${y}
                L ${x + loopWidth} ${y + loopHeight}
                L ${x} ${y + loopHeight}`;
  return createGroup({}, [
    createPath(path, {
      stroke: theme.edge.stroke,
      "stroke-width": theme.edge.strokeWidth,
      fill: "none",
      "marker-end": "url(#arrow)"
    }),
    createText(x + loopWidth + 5, y + loopHeight / 2, label, {
      "text-anchor": "start",
      fill: theme.node.color,
      "font-size": 12,
      "font-family": theme.node.fontFamily
    })
  ]);
}
function renderNote(x, y, text, position, theme) {
  const noteWidth = Math.max(NOTE_WIDTH, measureTextWidth(text, 12) + NOTE_PADDING * 2);
  const noteHeight = 30;
  const foldSize = 8;
  let noteX = x;
  if (position === "left") {
    noteX = x - noteWidth - 20;
  } else if (position === "right") {
    noteX = x + 20;
  } else {
    noteX = x - noteWidth / 2;
  }
  const notePath = `M ${noteX} ${y}
                    L ${noteX + noteWidth - foldSize} ${y}
                    L ${noteX + noteWidth} ${y + foldSize}
                    L ${noteX + noteWidth} ${y + noteHeight}
                    L ${noteX} ${y + noteHeight}
                    Z
                    M ${noteX + noteWidth - foldSize} ${y}
                    L ${noteX + noteWidth - foldSize} ${y + foldSize}
                    L ${noteX + noteWidth} ${y + foldSize}`;
  return createGroup({}, [
    createPath(notePath, {
      fill: theme.note.fill,
      stroke: theme.note.stroke,
      "stroke-width": 1
    }),
    createText(noteX + noteWidth / 2, y + noteHeight / 2, text, {
      fill: theme.note.color,
      "font-size": theme.note.fontSize
    })
  ]);
}
function renderFragment(fragment, x, y, width, height, theme) {
  const labelWidth = measureTextWidth(fragment.type.toUpperCase(), 10) + 20;
  const labelHeight = 20;
  const elements = [
    // Main frame
    createRect(x, y, width, height, {
      fill: theme.fragment.fill,
      stroke: theme.fragment.stroke,
      "stroke-width": 1
    }),
    // Label background
    createPath(
      `M ${x} ${y}
       L ${x + labelWidth} ${y}
       L ${x + labelWidth + 10} ${y + labelHeight}
       L ${x} ${y + labelHeight}
       Z`,
      {
        fill: theme.fragment.labelBackground,
        stroke: theme.fragment.stroke,
        "stroke-width": 1
      }
    ),
    // Label text
    createText(x + labelWidth / 2, y + labelHeight / 2 + 2, fragment.type.toUpperCase(), {
      fill: theme.fragment.labelColor,
      "font-size": 10,
      "font-weight": "bold"
    })
  ];
  if (fragment.label) {
    elements.push(
      createText(x + labelWidth + 15, y + labelHeight / 2 + 2, `[${fragment.label}]`, {
        "text-anchor": "start",
        fill: theme.fragment.labelColor,
        "font-size": 10,
        "font-style": "italic"
      })
    );
  }
  return createGroup({}, elements);
}
function renderSequenceToSvg(schema, theme, warningCollector) {
  const layout2 = {
    participantX: /* @__PURE__ */ new Map(),
    currentY: MARGIN + 80,
    // Start below participant headers
    activations: /* @__PURE__ */ new Map(),
    width: 0
  };
  let x = MARGIN + PARTICIPANT_SPACING / 2;
  for (const participant of schema.participants) {
    layout2.participantX.set(participant.id, x);
    layout2.activations.set(participant.id, []);
    x += PARTICIPANT_SPACING;
  }
  layout2.width = x + MARGIN;
  const processedEvents = [];
  for (const event of schema.events) {
    const startY = layout2.currentY;
    switch (event.type) {
      case "message": {
        const fromX = layout2.participantX.get(event.data.from);
        const toX = layout2.participantX.get(event.data.to);
        if (fromX === void 0) {
          warningCollector.warn(
            "UNKNOWN_PARTICIPANT_REFERENCE",
            `Message references unknown participant: ${event.data.from}`,
            { participantId: event.data.from }
          );
        }
        if (toX === void 0) {
          warningCollector.warn(
            "UNKNOWN_PARTICIPANT_REFERENCE",
            `Message references unknown participant: ${event.data.to}`,
            { participantId: event.data.to }
          );
        }
        processedEvents.push({ event, y: startY, height: MESSAGE_HEIGHT });
        layout2.currentY += MESSAGE_HEIGHT;
        break;
      }
      case "selfMessage": {
        if (!layout2.participantX.has(event.data.participant)) {
          warningCollector.warn(
            "UNKNOWN_PARTICIPANT_REFERENCE",
            `Self-message references unknown participant: ${event.data.participant}`,
            { participantId: event.data.participant }
          );
        }
        processedEvents.push({ event, y: startY, height: MESSAGE_HEIGHT + 10 });
        layout2.currentY += MESSAGE_HEIGHT + 10;
        break;
      }
      case "activate": {
        const activations = layout2.activations.get(event.data.participant);
        if (activations) {
          activations.push({ startY: layout2.currentY, count: 1 });
        }
        break;
      }
      case "deactivate": {
        const activations = layout2.activations.get(event.data.participant);
        if (activations?.length) activations[activations.length - 1].count = layout2.currentY - activations[activations.length - 1].startY;
        break;
      }
      case "note": {
        processedEvents.push({ event, y: startY, height: 40 });
        layout2.currentY += 40;
        break;
      }
      case "fragment": {
        const fragmentHeight = event.data.sections.reduce(
          (sum, section) => sum + section.content.length * MESSAGE_HEIGHT + 30,
          30
        );
        processedEvents.push({
          event,
          y: startY,
          height: fragmentHeight,
          fragmentInfo: {
            x: MARGIN,
            width: layout2.width - MARGIN * 2,
            sections: event.data.sections.map((section, i) => ({
              y: startY + 30 + i * (fragmentHeight / event.data.sections.length),
              label: section.label
            }))
          }
        });
        layout2.currentY += fragmentHeight;
        break;
      }
    }
  }
  const totalHeight = layout2.currentY + MARGIN + PARTICIPANT_HEIGHT;
  const elements = [];
  const arrowColor = theme.edge.stroke ?? "#333";
  const defs = createElement("defs", {}, [
    createArrowMarker("arrow", arrowColor, 8)
  ]);
  elements.push(defs);
  const viewBox = { x: 0, y: 0, width: layout2.width, height: totalHeight };
  const bgStyle = schema.background ?? theme.background;
  const bgElement = createBackground(viewBox, bgStyle);
  if (Array.isArray(bgElement)) {
    elements.push(bgElement[0]);
    elements.push(bgElement[1]);
  } else {
    elements.push(bgElement);
  }
  for (const participant of schema.participants) {
    const px = layout2.participantX.get(participant.id);
    if (px === void 0) continue;
    const lifelineTop = MARGIN + 80;
    const lifelineBottom = totalHeight - PARTICIPANT_HEIGHT - MARGIN;
    elements.push(
      createLine(px, lifelineTop, px, lifelineBottom, {
        stroke: theme.edge.stroke,
        "stroke-width": 1,
        "stroke-dasharray": "5,3"
      })
    );
  }
  layout2.activations.forEach((acts, pid) => {
    const px = layout2.participantX.get(pid);
    if (px !== void 0) acts.filter((a) => a.count > 0).forEach((a) => {
      const h = Math.max(a.count, 20);
      elements.push(createRect(px - 10, a.startY, 20, h, { fill: "none", stroke: theme.edge.stroke, "stroke-width": 1 }));
    });
  });
  for (const participant of schema.participants) {
    const px = layout2.participantX.get(participant.id);
    if (px === void 0) continue;
    if (participant.type === "actor") {
      elements.push(renderActor(px, MARGIN, participant.label, theme));
    } else {
      elements.push(renderParticipantBox(px, MARGIN, participant.label, theme));
    }
  }
  for (const participant of schema.participants) {
    const px = layout2.participantX.get(participant.id);
    if (px === void 0) continue;
    elements.push(
      renderParticipantBox(px, totalHeight - PARTICIPANT_HEIGHT - MARGIN, participant.label, theme)
    );
  }
  const activeActivations = /* @__PURE__ */ new Map();
  for (const participant of schema.participants) {
    activeActivations.set(participant.id, []);
  }
  for (const processed of processedEvents) {
    const { event, y } = processed;
    switch (event.type) {
      case "message": {
        const fromX = layout2.participantX.get(event.data.from);
        const toX = layout2.participantX.get(event.data.to);
        if (fromX !== void 0 && toX !== void 0) {
          elements.push(
            renderMessage(fromX, toX, y, event.data.label, event.data.dashed ?? false, theme)
          );
        }
        break;
      }
      case "selfMessage": {
        const px = layout2.participantX.get(event.data.participant);
        if (px !== void 0) {
          elements.push(renderSelfMessage(px, y, event.data.label, theme));
        }
        break;
      }
      case "note": {
        const noteParticipants = Array.isArray(event.data.participants) ? event.data.participants : [event.data.participants];
        const firstParticipant = noteParticipants[0];
        if (firstParticipant) {
          const px = layout2.participantX.get(firstParticipant);
          if (px !== void 0) {
            elements.push(renderNote(px, y, event.data.text, event.data.position, theme));
          }
        }
        break;
      }
      case "fragment": {
        if (processed.fragmentInfo) {
          elements.push(
            renderFragment(
              event.data,
              processed.fragmentInfo.x,
              y,
              processed.fragmentInfo.width,
              processed.height,
              theme
            )
          );
          if (event.data.sections.length > 1 && processed.fragmentInfo.sections.length > 1) {
            for (let i = 1; i < processed.fragmentInfo.sections.length; i++) {
              const section = processed.fragmentInfo.sections[i];
              elements.push(
                createLine(
                  processed.fragmentInfo.x,
                  section.y,
                  processed.fragmentInfo.x + processed.fragmentInfo.width,
                  section.y,
                  {
                    stroke: theme.fragment.stroke,
                    "stroke-width": 1,
                    "stroke-dasharray": "5,3"
                  }
                )
              );
              elements.push(
                createText(processed.fragmentInfo.x + 10, section.y + 15, `[${section.label}]`, {
                  "text-anchor": "start",
                  fill: theme.fragment.labelColor,
                  "font-size": 10,
                  "font-style": "italic"
                })
              );
            }
          }
        }
        break;
      }
    }
  }
  const root = createElement("g", {}, elements);
  return serializeSvg(root, viewBox, layout2.width, totalHeight);
}

// src/browser.ts
function validateFlowchartSchema(schema) {
  const errors = [];
  const warnings = [];
  if (!Array.isArray(schema.nodes)) {
    errors.push("nodes must be an array");
  } else {
    const nodeIds = /* @__PURE__ */ new Set();
    for (const node of schema.nodes) {
      if (!node.id) {
        errors.push("Each node must have an id");
      } else {
        if (nodeIds.has(node.id)) {
          warnings.push(`Duplicate node id: ${node.id}`);
        }
        nodeIds.add(node.id);
      }
      if (!node.label) {
        warnings.push(`Node "${node.id}" has no label, using id as label`);
      }
    }
    if (Array.isArray(schema.edges)) {
      for (const edge of schema.edges) {
        if (!nodeIds.has(edge.from)) {
          warnings.push(`Edge references unknown source node: ${edge.from}`);
        }
        if (!nodeIds.has(edge.to)) {
          warnings.push(`Edge references unknown target node: ${edge.to}`);
        }
      }
    }
  }
  if (schema.edges && !Array.isArray(schema.edges)) {
    errors.push("edges must be an array");
  }
  return { valid: errors.length === 0, errors, warnings };
}
function validateSequenceSchema(schema) {
  const errors = [];
  const warnings = [];
  if (!Array.isArray(schema.participants)) {
    errors.push("participants must be an array");
  } else {
    const participantIds = /* @__PURE__ */ new Set();
    for (const p of schema.participants) {
      if (!p.id) {
        errors.push("Each participant must have an id");
      } else {
        if (participantIds.has(p.id)) {
          warnings.push(`Duplicate participant id: ${p.id}`);
        }
        participantIds.add(p.id);
      }
    }
  }
  if (schema.events && !Array.isArray(schema.events)) {
    errors.push("events must be an array");
  }
  return { valid: errors.length === 0, errors, warnings };
}
function renderFlowchart(schema) {
  const warningCollector = new WarningCollector();
  const theme = schema.theme && isValidTheme(schema.theme) ? getTheme(schema.theme) : getDefaultTheme();
  return renderFlowchartToSvg(schema, theme, warningCollector);
}
function renderSequence(schema) {
  const warningCollector = new WarningCollector();
  const theme = schema.theme && isValidTheme(schema.theme) ? getTheme(schema.theme) : getDefaultTheme();
  return renderSequenceToSvg(schema, theme, warningCollector);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DiagramScriptError,
  WarningCollector,
  blueprintTheme,
  darkTheme,
  extendTheme,
  getAvailableThemes,
  getAvailableVariants,
  getDefaultTheme,
  getTheme,
  isValidTheme,
  isValidVariant,
  lightTheme,
  minimalTheme,
  renderFlowchart,
  renderSequence,
  validateFlowchartSchema,
  validateSequenceSchema
});
